import { render, staticRenderFns } from "./PointBackHistoryList.vue?vue&type=template&id=12f2aa8b&scoped=true"
import script from "./PointBackHistoryList.vue?vue&type=script&lang=js"
export * from "./PointBackHistoryList.vue?vue&type=script&lang=js"
import style0 from "./PointBackHistoryList.vue?vue&type=style&index=0&id=12f2aa8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f2aa8b",
  null
  
)

export default component.exports